module.exports = __webpack_public_path__ + "assets/img/36.09d3e32a.png";